package com.arena_web.ui.components.widgets

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle

/**
 * Hides the native scrollbar across browsers while keeping the element scrollable.
 *
 * Apply via `HiddenScrollbarStyle.toModifier()` (or `.toAttrs()` for raw `Div`s).
 * The element still needs `overflow-x: auto` / `overflow-y: auto` set by the caller.
 *
 * Covers Firefox (`scrollbar-width: none`), legacy Edge/IE (`-ms-overflow-style: none`),
 * and WebKit (`::-webkit-scrollbar { display: none }`).
 */
val HiddenScrollbarStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("scrollbar-width", "none")
            property("-ms-overflow-style", "none")
        }
    }
    cssRule("::-webkit-scrollbar") {
        Modifier.styleModifier {
            property("display", "none")
        }
    }
}
